import { render, staticRenderFns } from "./LocationController.vue?vue&type=template&id=032539e3"
import script from "./LocationController.vue?vue&type=script&lang=js"
export * from "./LocationController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports